<template>

  <div>
    <b-modal
      id="import-modal"
      ref="import-modal"
      title="Excel'den E Posta Adresi Aktar"
      :ok-title="$t('İçe Aktarmayı Başlat')"
      :cancel-title="$t('Vazgeç')"
      :hide-footer="hideModalFooter"
      @show="resetImportModal"
      @hidden="resetImportModal"
      @ok="startImport"
    >
      <b-overlay
        :show="importModalOverlayShow"
        rounded="sm"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <span>Excel dosyasında ilk sütuna e posta adresleri sıralanmalıdır.</span>
          </div>
        </b-alert>
        <b-form-group
          :label="$t('Excel Dosyası')"
          label-for="image_file_path"
        >
          <b-form-file
            id="image_file_path"
            accept=".xls, .xlsx"
            :placeholder="$t('Bir dosya seçiniz veya buraya sürükleyiniz')"
            :drop-placeholder="$t('Dosyayı buraya bırakınız...')"
            @change="onFileChange"
          />

        </b-form-group>
        <span v-if="excelImportRows"><strong>{{ excelImportRows.length }}</strong> Adet Kayıt Bulundu</span>
      </b-overlay>
    </b-modal>
    <product-list-add-new
      :is-add-new-product-sidebar-active.sync="isAddNewProductSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
      @addIsSuccess="addIsSuccess"
    />

    <!-- Filters -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Gösterilen') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('Kayıtlar') }}</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                v-if="$can('read', 'product_edit')"
                variant="primary"
                @click="isAddNewProductSidebarActive = true"
              >
                <span class="text-nowrap">{{ $t('Yeni Ürün Ekle') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <hr>
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0 "
          >
            <b-button
              variant="primary"
              size="sm"
              @click="toExcel"
            >
              <feather-icon
                icon="FileTextIcon"
                class="mr-50"
              />
              <span class="text-nowrap">{{ $t('Tümünü Excel Olarak İndir') }}</span>
            </b-button>
            <b-button
              v-if="$can('read', 'product_edit')"
              id="import-modal-toggle-btn"
              v-b-modal.import-modal
              variant="dark"
              size="sm"
            >
              <feather-icon
                icon="UploadIcon"
                class="mr-50"
              />
              <span class="text-nowrap">{{ $t("Excel'den İçer Aktar") }}</span>
            </b-button>

          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refProductListTable"
        class="position-relative"
        :items="fetchProducts"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        small
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(main_image_url)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.main_image_url"
              />
            </template>

          </b-media>
        </template>
        <template #cell(price)="data">
          {{ $staticParams.formatCurrency(data.item.price,4)+' '+data.item.currency_code }}
        </template>
        <template #cell(stocks)="data">
          <app-collapse>

            <app-collapse-item :title="$t('Stokları Gör')+' ('+data.item.total_stock+' '+$t('Toplam Stok')+')'">
              <b-list-group>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                >
                  <span><strong>{{ $t('Depo') }}</strong></span>
                  <b-badge
                    variant="primary"
                    pill
                    class="badge-round"
                  >
                    {{ $t('Stok')+'/'+$t('Rezerve') }}
                  </b-badge>
                </b-list-group-item>
                <b-list-group-item
                  v-for="(item, index) in data.item.stocks"
                  :key="index"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span>{{ item.store_name }}</span>
                  <b-badge
                    variant="primary"
                    pill
                    class="badge-round"
                  >
                    {{ item.stock }}/{{ item.stock_reserved }}
                  </b-badge>
                </b-list-group-item>
              </b-list-group>
            </app-collapse-item>
          </app-collapse>
        </template>
        <template #cell(creator)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-badge
                v-if="data.item.creator==1"
                variant="primary"
                pill
                class="badge-round"
              >
                {{ $t('Manuel Oluşturulan') }}
              </b-badge>
              <b-badge
                v-if="data.item.creator!=1"
                variant="warning"
                pill
                class="badge-round"
              >
                {{ $t('Otomatik Oluşturulan') }}
              </b-badge>
            </template>

          </b-media>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="$can('read', 'product_edit')"
              :to="{ name: 'products-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Düzenle') }}</span>
            </b-dropdown-item>

          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Gösterilen') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{ $t('Entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalProducts"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BDropdown, BDropdownItem, BPagination, BBadge, BModal, BFormFile,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import readXlsxFile from 'read-excel-file'
import useJwt from '@/auth/jwt/useJwt'
import useProductsList from './useProductList'
import productStoreModule from '../productStoreModule'
import ProductListAddNew from './ProductListAddNew.vue'

export default {
  components: {
    ProductListAddNew,
    BCard,
    BRow,
    BCol,
    BModal,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BFormFile,
    BAvatar,
    AppCollapse,
    AppCollapseItem,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBadge,
    vSelect,
  },
  methods: {
    toExcel() {
      const excelUrl = `${process.env.VUE_APP_API_URL}/api/product-excel?token=${useJwt.getToken()}`
      window.location.href = `${excelUrl}`
    },
    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },
    resetImportModal() {
      this.excelImportRows = null
    },
    startImport(bvModalEvt) {
      this.importModalOverlayShow = true
      bvModalEvt.preventDefault()
      store.dispatch('app-product/addProductsBulk', { data_arr: this.excelImportRows })
        .then(() => {
          this.$nextTick(() => {
            this.$refs['import-modal'].toggle('#import-modal-toggle-btn')
          })
          this.showSuccessMessage()
          this.importModalOverlayShow = false
        }).catch(() => {
          this.importModalOverlayShow = false
          this.showErrorMessage()
        })

      // Prevent modal from closing

      // Trigger submit handler
    },
    onFileChange(event) {
      const xlsxfile = event.target.files ? event.target.files[0] : null
      this.excelImportRows = []
      readXlsxFile(xlsxfile).then(rows => {
        let counter = 0
        rows.forEach(val => {
          // eslint-disable-next-line no-plusplus
          counter++
          if (counter >= 2) {
            const importData = {
              stock_code: val[0],
              product_name: val[1],
              product_name_en: val[2],
              description: val[3],
              unit_name: val[4],
              price: val[5],
              currency: val[6],

            }

            this.excelImportRows.push(importData)
          }
        })
      })
    },
    addIsSuccess(id) {
      this.editProductId = id
      this.isEditProductSidebarActive = true
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-product'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, productStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })
    const editProductId = ref(0)
    const isAddNewProductSidebarActive = ref(false)
    const isEditProductSidebarActive = ref(false)

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ]

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ]

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalProducts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductListTable,
      refetchData,

      // UI

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useProductsList()

    return {

      // Sidebar
      isAddNewProductSidebarActive,
      isEditProductSidebarActive,
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalProducts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      editProductId,
      isSortDirDesc,
      refProductListTable,
      refetchData,

      // Filter
      avatarText,

      // UI

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
